import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {
  Termsandconditions,
  PrivacyPolicy,
  NotFound,
  ContactUs,
  DeleteAccount,
} from "./pages";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import data from "./config.json";
import "./style/App.scss";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App data={data} />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicy data={data} />} />
      <Route
        path="/termsandconditions"
        element={<Termsandconditions data={data} />}
      />
      <Route path="/contactus" element={<ContactUs data={data} />} />
      <Route path="/delete_account" element={<DeleteAccount data={data} />} />
      <Route path="*" element={<NotFound data={data} />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
